// extracted by mini-css-extract-plugin
export var active = "_f6-2";
export var recordingDot = "_f6-1";
export var recordingIndicator = "_f6-0";